import DeleteIcon from "@mui/icons-material/Delete";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import deleteAllowance from "@/features/allowance/api/deleteAllowance";
import { RDialog } from "@/shared/components/forms";

type DeleteAllowanceButtonProps = {
  allowanceId: string;
  refetchAllowance: () => void;
};

export default function DeleteAllowanceButton({
  allowanceId,
  refetchAllowance,
}: DeleteAllowanceButtonProps) {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleDeleteAllowance = async () => {
    try {
      await deleteAllowance(allowanceId);
      refetchAllowance();
    } catch (error) {
      // @todo deal with error
    }
    handleClose();
  };

  return (
    <>
      <MenuItem key="delete" onClick={handleOpen}>
        <DeleteIcon fontSize="small" />
      </MenuItem>
      <RDialog
        isOpen={isModalOpen}
        title="Delete Selected Allowance"
        cancelButtonCallback={handleClose}
        confirmButtonCallback={handleDeleteAllowance}
        confirmButtonText="Delete"
        confirmButtonType="error"
        size="small">
        <Typography variant="h5" sx={{ textAlign: "center" }}>
          Are you sure you want to delete the selected allowance?
        </Typography>
      </RDialog>
    </>
  );
}
